// extracted by mini-css-extract-plugin
export default {"pane":"Pane_pane__6hFrE","vertical":"Pane_vertical__C2MDp","horizontal":"Pane_horizontal__G36g4","section":"Pane_section__f0i57","grow":"Pane_grow__EGUCb"};